import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { getImageProcessingInfo } from '../../imageprocessing/actions/ImageProcessingActions';
import * as Actions from '../Actions';
import { isDigitalStylingOrder, isPhotoOrder } from '../orderTypeChecks';
import { selectBasicOrderInfo } from '../Reducer';
import {
    basicOrderInfoQueryKey,
    imageProcessingInfoQueryKey,
    suspenseSafeCacheTime
} from './useBasicOrderInfoData';

const suspenseQueryBehavior = {
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    cacheTime: suspenseSafeCacheTime,
    suspense: true,
    useErrorBoundary: false
};

export function useImageProcessingInfoSuspense(orderId: number): void {
    const dispatch = useDispatch<any>();
    const order = useSelector(selectBasicOrderInfo);

    useQuery([basicOrderInfoQueryKey, orderId], () => dispatch(Actions.view(orderId)), {
        ...suspenseQueryBehavior
    });

    useQuery(
        [imageProcessingInfoQueryKey, orderId],
        () => dispatch(getImageProcessingInfo(orderId)),
        {
            ...suspenseQueryBehavior,
            enabled: isPhotoOrder(order) || isDigitalStylingOrder(order)
        }
    );
}
